export default {
  SET_SALES_CONSULTANT: (state, data) => {
    state.sales_consultant = data;
  },
  SET_SALES_CONSULTANTS: (state, data) => {
    state.sales_consultants = data;
  },
};
